import { useEffect, useState } from "react";
import { Layout } from "../layout";
import styled from 'styled-components';
import { useQueryParamsHook } from "../../../utils/useQueryParamsHook";
import { WegetCreate } from "./wegets/weget-create";
import { WegetList } from "./wegets/weget-list";
import { useApiInfoContextValueHook } from "../../../contexts/ApiInfoContext";
import { useFetcher } from "./fetcher/useFetcher";
import { WegetEdit } from "./wegets/weget-edit";

const StyledContainer = styled.div`
    background-color: var(--backgroundField);
    min-height:100vh;
    padding-bottom: 200px;
`;

export function MainView(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const queryParamsHook = useQueryParamsHook();
    const viewType = queryParamsHook?.params?.viewType || 'LIST'; // LIST, CREATE, EDIT

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        fetcher.fetchReturnExchangeDownloadForms();
    }, [
        apiInfoContextValueHook?.apiInfo?.apiKey,
        apiInfoContextValueHook?.apiInfo?.secretKey,
    ])

    return (
        <>
            <Layout>
                {viewType === 'LIST' &&
                    <StyledContainer>
                        <WegetList />
                    </StyledContainer>
                }
                {viewType === 'CREATE' &&
                    <StyledContainer>
                        <WegetCreate />
                    </StyledContainer>
                }
                {viewType === 'EDIT' &&
                    <StyledContainer>
                        <WegetEdit />
                    </StyledContainer>
                }
            </Layout>
        </>
    );
}